import { Skeleton, Typography, styled, useTheme } from '@mui/material';
import { kebabCase } from 'lodash-es';
import { watchProviderLinks } from '#enums/watchProviders.ts';
import { type RequiredWatchProviderFields } from './types.ts';

const Image = styled('img')(({ theme }) => ({
  borderRadius: theme.spacing(1),
  display: 'block',
  objectFit: 'cover',
  objectPosition: 'center',
  width: '100%',
}));

const ProvidersCategoryContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1.5),
}));

const LogosContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  picture: {
    display: 'inline-block',
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

const LogoLink = styled('a')(() => ({}));

export type ComponentProps = {
  providers: [string, RequiredWatchProviderFields[]][];
};

export const Component = ({ providers }: ComponentProps) => {
  const theme = useTheme();

  return (
    <div>
      {providers.length > 0
        ? providers.map(([categoryName, categoryProviders]) => (
            <ProvidersCategoryContainer key={kebabCase(categoryName)}>
              <Typography
                sx={{
                  color: theme.supportingTextPrimary,
                  fontSize: '0.75rem',
                  textTransform: 'uppercase',
                }}
              >
                {categoryName}
              </Typography>
              <LogosContainer>
                {categoryProviders.map(({ logoPath, providerName }) => {
                  const link = watchProviderLinks[providerName];

                  if (!link) {
                    console.error('Watch provider link missing:', providerName);
                  }

                  return link ? (
                    <LogoLink href={link} key={kebabCase(providerName)} target="_blank">
                      <picture>
                        <Image alt={providerName} src={logoPath} />
                      </picture>
                    </LogoLink>
                  ) : (
                    <picture key={kebabCase(providerName)}>
                      <Image alt={providerName} src={logoPath} />
                    </picture>
                  );
                })}
              </LogosContainer>
            </ProvidersCategoryContainer>
          ))
        : Array.from({ length: 2 }).map((_, indexA) => (
            <ProvidersCategoryContainer key={indexA}>
              <Skeleton sx={{ fontSize: '0.75rem' }} variant="text" width={80} />
              <LogosContainer>
                {Array.from({ length: 6 }).map((__, indexB) => (
                  <Skeleton
                    height={45}
                    key={indexB}
                    sx={{ fontSize: '0.75rem', marginRight: theme.spacing(1), marginTop: theme.spacing(1) }}
                    variant="rounded"
                    width={45}
                  />
                ))}
              </LogosContainer>
            </ProvidersCategoryContainer>
          ))}
    </div>
  );
};
